
function doFunction() {

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-carica-consumi-file',
      title: 'Caricamento Consumi EE',
      data: {type:'ee'},
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': doFunction,
}
